// Frontend ve backend'in ortak sözleşmesi.
// Buraya konan her şey iki tarafta da derlenmeli — Node'a özgü import yok.
//
// Sıra bağımlılık sırası: env/enums/plans hiçbir şeye dayanmıyor, common
// enums'a, alan dosyaları common'a. Barrel'da isim ÇAKIŞMASI olamaz —
// aynı adı iki dosya export ederse derleme kırılır ve bu iyi: iki alan aynı
// kavramı iki farklı şekilde tanımlamış demektir.

export * from './env.js';
export * from './enums.js';
export * from './auth.js';
export * from './plans.js';
export * from './common.js';
export * from './admin.js';

// ── Faz 1 alanları ────────────────────────────────────────────────────────
export * from './integrations.js';
export * from './analytics.js';
export * from './workspaces.js';
export * from './billing.js';
export * from './automation.js';
export * from './notifications.js';
// ── Faz 3 ─────────────────────────────────────────────────────────────────
export * from './messaging.js';
export * from './agent.js';
/**
 * MANKEN KADROSU — `creative.js`ten ÖNCE ve bu sıra zorunlu.
 *
 * `creative.ts` buradan `presenterParamsSchema`yı DEĞER olarak alıyor.
 * Barrel bu satırı sonra değerlendirseydi şema `creative.ts` çalışırken
 * henüz tanımlı olmazdı (TDZ) — hata derlemede değil, ilk istekte çıkardı.
 *
 * Reçeteler (kim nasıl duruyor, ürünü nasıl tutuyor) BURADA DEĞİL:
 *     import { buildPresenterInstruction } from '@mentorivo/shared/studio-model-recipes';
 */
export * from './studio-models.js';
export * from './creative.js';
/**
 * Kreatif direktörü sohbetinin UÇ sözleşmesi (21 Ağu 2026).
 *
 * BRIEF'İ burada değil (`./creative-director-brief.ts`, alt yoldan): modele
 * işi öğreten metin ürünün kendisi ve tüketicisi yalnız sunucu.
 *     import { buildDirectorSystemPrompt } from '@mentorivo/shared/creative-director-brief';
 */
export * from './creative-director.js';
/**
 * Beceri kataloğu — sohbetin giriş kapısı. `creative-director.js`ten SONRA:
 * reçeteler `DirectorForm` tipini okuyor.
 */
export * from './creative-skills.js';
/**
 * Kampanya direktörü sohbetinin UÇ sözleşmesi (22 Ağu 2026).
 *
 * Kreatif direktörüyle AYNI desen ve aynı ayrım: brief burada DEĞİL
 * (`./campaign-director-brief.ts`, alt yoldan). İkisi ayrı sohbet ve ayrı
 * form — ortak tek şey günlük sayaç (`AgentLimitService`).
 */
export * from './campaign-director.js';
// ── Faz 4 ─────────────────────────────────────────────────────────────────
// `agent.js` ajanın SOHBET yüzü, `agents.js` KİMLİK yüzü. İsim çakışması
// olamaz (barrel derlemesi kırılır) — ikisi bilerek ayrı ad uzayları.
export * from './agents.js';

// ── Faz 5 ─────────────────────────────────────────────────────────────────
// Anahtar kelime / arama terimi okuma sözleşmesi. `analytics.js`ten AYRI
// çünkü platformdan bağımsız DEĞİL — Meta'da bu kavram yok.
export * from './keywords.js';
// RMF = kampanya/ad set/reklam OLUŞTURMA uçları. `analytics.js` aynı
// varlıkları OKUYOR ve DEĞİŞTİRİYOR; oluşturma ayrı bir dosyada çünkü girdisi
// tamamen farklı (hedefleme, faturalama olayı, kreatif) ve o alanların
// okuma sözleşmesinde hiçbir karşılığı yok.
export * from './rmf.js';

// ── Adım 4 — kampanya ekranları ───────────────────────────────────────────
// `analytics.js` ile `rmf.js` arasındaki BOŞLUKLAR. Yeni bir uç sözleşmesi
// değil: uçların hepsi zaten canlı, eksik olan o uçları tüketen ekranın
// kararlarıydı — hangi metrik hangi kapsamda anlamlı, seçim tavanı kaç,
// boş durumun dört hâlinden hangisi. Üç ekran (tablo, kolon seçici, rapor)
// o kararları ayrı ayrı yorumlarsa üç farklı davranış doğar.
export * from './campaigns.js';
// Sihirbaz `campaigns.js`ten AYRI ve gerekçesi `rmf.js`in `analytics.js`ten
// ayrılma gerekçesiyle aynı: okumanın girdisi filtre ve dönem, oluşturmanın
// girdisi hedefleme, faturalama olayı ve marka kimliği. Ortak alanları yok.
//
// 🔴 Bu dosya ELLE YAZILMIŞ kataloglar taşıyor (hedef, optimizasyon,
// faturalama olayı). Sözleşmeden türetilebilir olsalardı türetilirdi;
// değiller — `createCampaignSchema.objective` serbest bir dize ve hiçbir uç
// seçilebilir değerleri yayımlamıyor. Ayrım dosyanın başlığında yazılı.
export * from './campaign-wizard.js';

// ── Faz 8 ─────────────────────────────────────────────────────────────────
// Demo veri modunun UÇ sözleşmesi. Veri ÜRETECİ (`demo-data.ts`) bilerek
// burada değil — `mail.ts` ile aynı gerekçe, alt yoldan okunuyor:
//     import { buildDemoDataset } from '@mentorivo/shared/demo-data';
export * from './demo.js';
// Destek bileti sözleşmesi. Yardım merkezi MAKALELERİ (`help-center.ts`)
// burada değil: 400 satır düz metin, tüketicisi yalnız API'nin `/help` ucu.
//     import { HELP_ARTICLES } from '@mentorivo/shared/help';
export * from './support.js';
// Blog SÖZLEŞMESİ — uç biçimi, konu listesi ve gövde blokları. Yazıların
// başlangıç METNİ burada değil (`./blog-seed.ts`, alt yoldan): tüketicisi
// yalnız tohum betiği ve iki dilde on iki yazı arayüz bundle'ına ait değil.
//     import { BLOG_SEED } from '@mentorivo/shared/blog-seed';
export * from './blog.js';

// ── Faz 6 ─────────────────────────────────────────────────────────────────
// Widget tabanlı pano. `analytics.js`ten AYRI: orada SORULAR (özet, seri,
// kırılım) tanımlı, burada o soruların panoya YERLEŞTİRİLMESİ. Widget
// çözümleyicileri analytics'i çağırıyor, kendi SQL'ini yazmıyor.
export * from './dashboard.js';

// ── Faz 7 ─────────────────────────────────────────────────────────────────
// Lead okuma sözleşmesi. `analytics.js`ten AYRI: lead bir METRİK değil bir
// KAYIT (kişisel veri taşıyan tekil satır) ve toplanamaz. Huni METRİKLERİ
// (`addToCart`, `purchases`…) `analytics.js`te kaldı — onlar toplanabilir.
export * from './leads.js';

// ── ./mail BİLEREK BURADA DEĞİL ───────────────────────────────────────────
// `mail.ts` posta HTML'i, konu satırları ve gönderim metinlerini taşıyor.
// `apps/web` bu barrel'ı import ediyor ve o içeriğin tarayıcıya gitmesi için
// hiçbir sebep yok. Erişim yalnız alt yoldan:
//
//     import { notificationEmail } from '@mentorivo/shared/mail';
//
// Buraya `export * from './mail.js'` eklemek ayrımı tek satırda siler.
// `packages/shared/src/mail-subpath.spec.ts` bunu doğruluyor.

// ── Genişleme Adım 1 ──────────────────────────────────────────────────────
// Mağaza bağlama, katalog, sipariş, stok. `integrations.js`ten AYRI ve
// gerekçesi dosyanın başlığında: mağazanın hiyerarşisi ve gün bazlı metriği
// YOK, buna karşılık kataloğu ve olay akışı VAR. Aynı dosyada tutmak iki
// kavramı birbirine karıştırırdı.
export * from './commerce.js';

// ── Genişleme Adım 7 ──────────────────────────────────────────────────────
// Video kreatif ekseni: süre, çözünürlük, en-boy oranı, ses, konuşma metni.
// `creative.js`ten AYRI ve gerekçesi dosyanın başlığında: bu altı alanın
// hiçbirinin görsel ya da metin üretiminde karşılığı yok, aynı dosyada
// tutmak alanların çoğu yalnız iki tipte anlamlı olan bir şema üretirdi.
export * from './video.js';

// ── ./video-templates BİLEREK BURADA DEĞİL ────────────────────────────────
// Şablon kataloğu prompt reçetelerinden ibaret ve tüketicisi SUNUCU: video
// hattı prompt'u ondan kuruyor, API uç noktası listesini döndürüyor. Arayüz
// kataloğu uçtan alıyor, bundle'dan değil. `./templates` (otomasyon) ve
// `./mail` ile aynı desen ve aynı gerekçe:
//
//     import { VIDEO_TEMPLATES } from '@mentorivo/shared/video-templates';

// ── Genişleme Adım 8 ──────────────────────────────────────────────────────
// Görsel stüdyo ekseni: sanal manken / kıyafet deneme, banner reçetesi,
// 2K büyütme, toplu üretim. `creative.js`ten AYRI ve gerekçesi dosyanın
// başlığında: bu modların hiçbiri yeni bir `CreativeType` açmıyor (üçü de
// AD_IMAGE ya da RESIZED üretiyor), ama her biri kendi eksenini getiriyor —
// manken tarifi, düzen bayrakları, büyütme hedefi. Aynı dosyaya koymak
// `creative.ts`i alanlarının çoğu yalnız üç modda anlamlı bir şemaya
// çevirirdi. `video.js` ile birebir aynı desen.
export * from './studio.js';

// ── ./banner-templates BİLEREK BURADA DEĞİL ───────────────────────────────
// Banner şablon kataloğu prompt reçetelerinden ibaret ve tüketicisi SUNUCU:
// stüdyo hattı prompt'u ondan kuruyor, `/creatives/studio/options` listesini
// döndürüyor. Arayüz kataloğu uçtan alıyor, bundle'dan değil.
// `./video-templates` ile aynı desen ve aynı gerekçe:
//
//     import { BANNER_TEMPLATES } from '@mentorivo/shared/banner-templates';

// ── Sahne şablonları — 19 Ağu 2026 ────────────────────────────────────────
// Görsel "reklam postu" reçeteleri. Barrel'da SÖZLEŞMESİ var, REÇETESİ yok ve
// ayrım bu adımın bütün sebebi: reçeteler o tarihe kadar
// `apps/web/src/lib/image-prompt-templates.ts` içinde, yani her ziyaretçinin
// indirdiği paketin İÇİNDE duruyordu.
//
//   · Kart tipleri (ad, açıklama, önizleme, yuva etiketleri) → burada, çünkü
//     arayüz `GET /creatives/studio/options` yanıtını bunlarla okuyor.
//   · Reçeteler → `@mentorivo/shared/scene-templates`, yalnız sunucu.
export * from './scene-public.js';

// ── ./scene-templates BİLEREK BURADA DEĞİL ────────────────────────────────
//     import { SCENE_TEMPLATES } from '@mentorivo/shared/scene-templates';

// ── Genişleme Adım 3 ──────────────────────────────────────────────────────
// Katalog zekâsı: ürün↔reklam köprüsü (feed kimliği ayrıştırma + deterministik
// eşleyici) ve ürün performans raporu sözleşmesi. `commerce.js`ten AYRI çünkü
// o dosya mağaza SENKRONUNU anlatıyor (bağlantı, okuma, webhook); buradakiler
// senkron bittikten SONRA katalogun üstünde çalışan kavramlar ve tüketicileri
// farklı — köprüyü worker, raporu API okuyor.
export * from './catalog.js';

// Katalog sağlığı kural listesi AYRI DOSYADA ve bilerek: "kural listesi tek
// yerde" bu adımın açık gereği, ayrı dosya o tekliği görünür kılıyor.
export * from './catalog-health.js';

// ── Google Merchant Center (19 Ağu 2026) ──────────────────────────────────
// Katalogun DIŞARIYA yayınlanması. `commerce.js`ten AYRI ve gerekçesi dosyanın
// başlığında: o dosya mağazanın OKUNMASINI anlatıyor (bağlan, ürün çek,
// sipariş çek, webhook), buradakilerin hiçbirinin orada karşılığı yok — data
// source, teklif kimliği, hedefteki onay durumu, çakışan feed. Ters yön de
// doğru: hedefin siparişi, stoğu, webhook'u yok.
//
// 🔴 İleride gelecek Meta CAPI / GA4 / Enhanced Conversions BURAYA GİRMEYECEK.
// Onlar OLAY hedefi, burası KATALOG hedefi; gerekçe dosyanın başlığında.
export * from './destination.js';

// ── Genişleme Adım 9 — ticari operasyon ───────────────────────────────────
// Fatura profili: kimlik doğrulaması (TCKN/VKN checksum), telefon
// normalizasyonu, maskeleme ve sağlayıcıya giden `BuyerIdentity`. Doğrulama
// SÖZLEŞMEDE çünkü arayüz ile sunucu aynı kararı vermek zorunda — kullanıcı
// "kaydet"e basmadan önce yanlış numarayı öğrenebilmeli.
export * from './billing-profile.js';

// Para hareketinin KAYDI: tahsilat, iade, e-belge. `billing.js`ten ayrı —
// o dosya aboneliğin ve kredinin DURUMUNU anlatıyor, buradakiler olan biteni.
export * from './payments.js';

// Satış operasyonu: demo talebi hunisi + atanmış hesap yöneticisi.
// 🔴 `leads.js` ile karıştırma — orası MÜŞTERİMİZİN reklamlarından gelen
// lead'ler (kiracıya ait), burası BİZE gelen aday müşteri (kiracısı yok).
export * from './sales.js';

// ── Şema borç turu — kreatif onayı + içerik moderasyonu ───────────────────
// Adım 8'in borç olarak devrettiği iki kalem. `creative.js`ten AYRI: orası
// üretimi (prompt, format, kredi), burası üretim bittikten SONRA verilen
// KARARLARI anlatıyor — insanın onayı ve sağlayıcının/insanın moderasyon
// kaydı. İkisi tek dosyada çünkü onaycı kararını moderasyon satırlarına
// bakarak veriyor; ayırmak, birbirini okumadan anlamı olmayan iki sözleşme
// üretirdi.
export * from './moderation.js';

// ── Genişleme Adım 10 — rakip analizi ─────────────────────────────────────
// Meta Ad Library satır eşleyicisi (SAF: ağ/saat/DB yok), `ads_archive`
// sözleşmesi, Google Auction Insights tipleri ve /competitors uç şemaları.
//
// 🔴 Ad Library `connector/`ın ALTINDA DEĞİL ve bu bir düzen tercihi değil:
// uç, kiracının OAuth jetonunu değil KİMLİK ONAYLI bir platform jetonunu
// istiyor (14 Ağu 2026'da `code 10 / subcode 2332004` ile ölçüldü).
// Gerekçenin tamamı dosyanın başlığında.
export * from './competitor.js';

// ── Akış motoru — grafik sözleşmesi (schemaVersion 2) ─────────────────────
// `automation.js`ten AYRI ve gerekçesi dosyanın başlığında: doğrusal kural
// (tetikleyici → koşul → kapsam → sıralı aksiyon) ile grafik AYRI iki belge ve
// yan yana yaşıyorlar. Düğüm `data` şekilleri `automation.js`ten İMPORT
// EDİLİYOR, kopyalanmıyor — grafik ikinci bir sözleşme değil, aynı
// sözleşmenin ikinci bir DİZİLİMİ.
export * from './automation-graph.js';

// v1 ↔ v2 dönüştürücüleri. Barrel'da olması ŞART: kayıtlı kurallar hâlâ v1 ve
// motor yalnız grafik yürütüyor — API, worker ve editör aynı dönüşümü çağırmak
// zorunda. İkinci bir kopya, kuru çalıştırma ile gerçek koşunun farklı
// grafikler görmesi demekti.
export * from './automation-graph-convert.js';

// ── Ürün görseli analizi → ürüne özel video planı ─────────────────────────
// `video.js` videonun EKSENİNİ (oran/süre/çözünürlük/ses) tanımlıyor, burası
// o eksende ÜRETİLECEK ŞEYİ: ürün fotoğrafının okunması ve o okumadan çıkan
// çekim planı. Barrel'da çünkü planı arayüz DÜZENLİYOR — sahne şablonlarının
// aksine reçete sunucuda kalamıyor, kullanıcının ürününe özel üretiliyor ve
// üretim isteğiyle geri geliyor. Gerekçenin tamamı dosyanın başlığında.
export * from './product-vision.js';

/// Backstage — platform yönetim paneli. Ürün sözleşmelerinden AYRI dosya:
/// buradaki tipler yalnızca backstage.mentorivo.com'da kullanılıyor ve
/// müşteri panelinin sözleşmeleriyle karışmamalı.
export * from './backstage.js';
